module.exports = {
          srcSet: __webpack_public_path__ + "871c1780b5e291d624d7f23dd1f2b715-2500.png"+" 2500w",
          images:[ {path: __webpack_public_path__ + "871c1780b5e291d624d7f23dd1f2b715-2500.png",width: 2500,height: 582}],
          src: __webpack_public_path__ + "871c1780b5e291d624d7f23dd1f2b715-2500.png",
          toString:function(){return __webpack_public_path__ + "871c1780b5e291d624d7f23dd1f2b715-2500.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACj//wCN//8WdP//B/8AAADxuZ8A77ipOefQcLrywGA0/4SlLP+MmgAA84qNAPKFmSPwtF8c/7hmAJJRlgDkwZ5Pp66byqfCvRS9wv8Qv8b/ADw7LTxDgNB2AAAAAElFTkSuQmCC",
          width: 2500,
          height: 582
        }